// extracted by mini-css-extract-plugin
module.exports = {"col":"cB_jw","row":"cB_bm"};